module.exports = __webpack_public_path__ + "static/use-case-2-content-1-d25d8360b9504fc90c67ca98a74eb600.png";